import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import QuoteBanner from "@/components/QuoteBanner";
import ConstituencySearch from "@/components/ConstituencySearch";
import Footer from "@/components/Footer";
import { useLang } from "@/context/LangContext";

export default function Candidates() {
  const { t, lang } = useLang();
  const ta = lang === "ta";
  const navigate = useNavigate();
  return (
    <div className="App">
      <Header compact title={t("nav_candidates")} />
      <QuoteBanner />
      <main className="max-w-4xl mx-auto px-6 pt-8 pb-24 min-h-[50vh]">
        <h2 className={`text-3xl sm:text-4xl font-semibold text-[#1a1640] tracking-tight ${ta ? "font-tamil" : "font-display"}`} data-testid="candidates-title">
          {t("candidates_title")}
        </h2>
        <p className={`mt-2 mb-6 text-[15px] text-[#6b6894] ${ta ? "font-tamil" : ""}`}>{t("candidates_sub")}</p>
        <ConstituencySearch onSelect={(item) => navigate(`/c/${encodeURIComponent(item.english)}`)} autofocus />
      </main>
      <Footer />
    </div>
  );
}
